import { RouteConfig } from 'vue-router';

import { TableName } from '@/enums/tableName.enum';
import { beforeCalendarRoute } from '@/routesUtils/calendar';
import store from '@/store/store';
import { tryParseInt } from '@/utils/number';
import TeamCalendar from '@/views/team/tabs/Calendar.vue';

export const teamCalendarRoute: RouteConfig = {
  path: 'calendar/:view',
  name: 'teamCalendar',
  component: TeamCalendar,
  meta: { title: 'titles.team.calendar' },
  beforeEnter: (to: any, from: any, next: any) => {
    store.commit('fee/setEntityType', TableName.Team);
    store.commit('presences/setEntityType', undefined);
    store.commit('presences/setEntityId', undefined);

    beforeCalendarRoute(
      to,
      tryParseInt(to.params.teamId) as number,
      TableName.Team,
      next,
      store.dispatch('team/player/list', { teamId: tryParseInt(to.params.teamId) })
    );
  }
};
